/**
 *
 * CustomSelectComponent
 *
 */

import { useState, useEffect, useRef } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  OutlinedInput,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as PropTypes from "prop-types";

const useStyles = makeStyles({
  root: {
    width: "100%",
    flex: 1,
    "&$focused": {
      "& > div": {
        borderRadius: ({ multiline }) => (multiline ? "15px" : "50px"),
        backgroundColor: "transparent",
      },
      "& > $notchedOutline": {
        borderColor: "rgba(0, 0, 0, 0.87)",
        color: "rgba(0, 0, 0, 0.87)",
        borderWidth: "1px",
        transition: "border-radius 250ms",
        backgroundColor: "transparent",
      },
      "& label": {
        color: "rgba(0, 0, 0, 0.87)",
      },
    },
  },
  focused: {
    borderRadius: ({ multiline }) => (multiline ? "15px" : "50px"),
  },
  notchedOutline: {
    borderRadius: ({ multiline }) => (multiline ? "15px" : "50px"),
  },
});

const useLabelStyles = makeStyles({
  root: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "90%",
    whiteSpace: "nowrap",
    "&$focused": { color: "rgb(159,159,159)" },
  },
  focused: {},
});

function CustomInputComponent({
  label,
  value,
  onChange,
  className,
  multiline = false,
  fullWidth = false,
  isError = false,
  helperText = "",
  isRequired = false,
  disabled = false,
}) {
  const inputLabel = useRef();
  const classes = useStyles({
    multiline,
  });
  const labelClasses = useLabelStyles();
  const [labelWidth, setLabelWidth] = useState(0);

  useEffect(() => {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  return (
    <FormControl
      className={className}
      fullWidth={fullWidth}
      variant="outlined"
      htmlFor={inputLabel}
      disabled={disabled}
      error={isError}
      data-cy={label}
    >
      <InputLabel
        variant="outlined"
        classes={labelClasses}
        margin="dense"
        ref={inputLabel}
      >
        {label}
      </InputLabel>
      <OutlinedInput
        classes={classes}
        value={value}
        disabled={disabled}
        multiline={multiline}
        {...(multiline ? { rows: 0 } : {})}
        margin="dense"
        onChange={onChange}
        labelWidth={labelWidth}
        required={isRequired}
        data-cy="inputComponent"
      />
      {isError && (
        <FormHelperText id="component-helper-text">{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

CustomInputComponent.propTypes = {
  value: PropTypes.any,
  label: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
  isError: PropTypes.bool,
  isRequired: PropTypes.bool,
  helperText: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CustomInputComponent;
